import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const WeavingShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Weaving Section"
    sectionKey="Weaving Section"
    backRoute="/sections/weaving"
  />
);

export default WeavingShipmentRequest;
